import React from 'react'
import {
  CookieBanner as StylistCookieBanner,
  DefaultCookiePolicy
} from 'stylist'

const CookieBanner = ({ onAccept, highlighted }) => (
  <StylistCookieBanner onAccept={onAccept} highlighted={highlighted}>
    <DefaultCookiePolicy />
  </StylistCookieBanner>
)

export default CookieBanner



// WEBPACK FOOTER //
// ./src/components/CookieAcceptance/CookieBanner.js